module.exports = __webpack_public_path__ + "files/6356c0f0bab0b467c67862ce6338b8fd.png";